import type { QueryCondition } from '@/types/api'
import type { TableColumnConfig } from '@/types/advanced-table'

export const REPORT_VIEW_CODE = {
  MANAGEMENT: 'MANAGEMENT',
  FOLLOW_UP: 'FOLLOW_UP'
} as const

export type ReportViewCode = typeof REPORT_VIEW_CODE[keyof typeof REPORT_VIEW_CODE]

/** 委托单费用页签实际使用的费用归类，由后端按数据权限查询。 */
export interface ReportFeeDimension {
  code: string
  name: string
  semanticType: 'NORMAL' | 'DUTY' | 'VAT'
}

export type ReportColumnKind = 'FIXED' | 'DYNAMIC_FEE'

/** 沿用发货申请单的 TableColumnConfig，仅补充报告金额格式与取值标识。 */
export interface ReportTableColumn extends TableColumnConfig {
  kind: ReportColumnKind
  valueCode?: string
  formatterCode?: string
}

export interface ReportSortCondition {
  fieldName: string
  direction: 'asc' | 'desc'
}

export interface ReportPageRequest {
  viewCode: ReportViewCode
  pageNum: number
  pageSize: number
  conditions: QueryCondition[]
  sorts: ReportSortCondition[]
}

export interface ReportDynamicAmount {
  currency?: string | null
  amount?: string | number | null
  valueState?: string | null
}

export interface ReportDynamicCell {
  amounts: ReportDynamicAmount[]
  missingRateCurrencies?: string[] | null
}

export interface ReportExceptionDetail {
  name: string
  objectType: 'TRANSPORT_CONSIGNMENT' | 'DISTRIBUTION_SHIPMENT' | 'WAYBILL'
  objectNos: string[]
}

/** 与后端报告行保持同一契约，不再兼容未使用的数组、扁平对象或路径取值格式。 */
export interface ReportListRecord {
  orderId: string | number
  shipmentIdsByNo?: Record<string, string>
  waybillIdsByNo?: Record<string, string>
  fixedFields: Record<string, unknown>
  dynamicCells: Record<string, ReportDynamicCell>
}

export interface ReportGridRow extends Record<string, unknown> {
  __rowKey: string
  orderId?: string | number | null
  consignmentNo?: string | null
  shipmentIdsByNo?: Record<string, string>
  waybillIdsByNo?: Record<string, string>
}

export interface ReportPageResponse {
  records: ReportListRecord[]
  total?: number | string
  size?: number
  current?: number
  pages?: number
}

export const REPORT_EXPORT_SCOPE = {
  ALL: 'ALL',
  SELECTED: 'SELECTED'
} as const

export type ReportExportScope = typeof REPORT_EXPORT_SCOPE[keyof typeof REPORT_EXPORT_SCOPE]

export interface ReportExportRequest extends ReportPageRequest {
  locale: string
  visibleColumnIds: string[]
  scope: ReportExportScope
  selectedOrderIds: string[]
}

export interface ReportExportFile {
  blob: Blob
  filename?: string
}
